import {
  OEButton,
  OEText,
  OETextInput,
  bottom,
  height,
  mb,
  mr,
  mt,
  position,
  right,
} from '@openeducation/oe-rn-components';
import { dateArrayToDate } from '@openeducation/oe-rn-services';
import { styled } from '@openeducation/oe-rn-themes';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { View } from 'react-native';

import { InfoItem } from '../../atoms/info-item/info-item';
import { useAskQuestion } from '../../hooks/use-ask-question';
import { useSupportedLanguage } from '../../hooks/use-supported-languages';
import type { AskTeacherQuestion } from '../../interfaces/ask-teacher-question';

const MAX_LENGTH = 1500;

interface QuestionContentProps {
  question: AskTeacherQuestion;
}

export const QuestionContent = ({ question }: QuestionContentProps) => {
  const { answerQuestion, isLoadingAnswer } = useAskQuestion();
  const { getLanguageName } = useSupportedLanguage();
  const [answer, setAnswer] = useState('');

  const sentAt = dateArrayToDate(question.date) ?? new Date();

  const handleSubmit = () => {
    answerQuestion({ answer });
  };

  return (
    <View>
      <StudentContainer>
        <InfoItem title="Sent" text={format(sentAt, 'PPp')} />
        <InfoItem title="From" text={question.studentDisplayName} />
        <InfoItem
          title="Native Language"
          text={getLanguageName(question.nativeLanguage)}
        />
        <InfoItem title="Level" text={question.level.toString()} />
        <InfoItem title="Unit" text={question.unit.toString()} />
      </StudentContainer>

      <View>
        <OEText style={mb(8)} fontSize={20} fontType="bold">
          Question
        </OEText>

        <OETextInput
          disabled
          multiline
          style={[height(140)]}
          onChangeText={() => null}
          value={question.text}
        />

        <OEText style={[mb(8), mt(16)]} fontSize={20} fontType="bold">
          Response
        </OEText>

        <View style={position('relative')}>
          <OETextInput
            multiline
            style={[height(140)]}
            disabled={isLoadingAnswer}
            onChangeText={(text) => setAnswer(text)}
            value={answer}
            maxLength={MAX_LENGTH}
            placeholder="Answer the question here"
            placeholderTextColor="#cccccc"
          />
          <OEText
            fontSize={12}
            style={[position('absolute'), right(12), bottom(8)]}
          >
            {answer.length} / {MAX_LENGTH}
          </OEText>
        </View>

        <SubmitContainer>
          {answer.length < 10 && (
            <ErrorMessage fontType="medium" style={mr(16)}>
              Response must contain more than 10 characters
            </ErrorMessage>
          )}
          <OEButton
            size="large"
            disabled={answer.length < 10}
            loading={isLoadingAnswer}
            onPress={handleSubmit}
          >
            Submit
          </OEButton>
        </SubmitContainer>
      </View>
    </View>
  );
};

const StudentContainer = styled(View)`
  background-color: ${({ theme }) => theme.color.lightPrimary};
  border-radius: 8px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 16px 24px;
  margin-bottom: 16px;
`;

const SubmitContainer = styled(View)`
  margin-top: 16px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const ErrorMessage = styled(OEText).attrs(({ theme, color }) => ({
  color: color || theme.color.danger,
}))``;
